// @flow strict

import * as React from 'react';
import classNames from '@ta/common.classnames';

import styles from './LoadingBar.css';

/** Component props for a LoadingBar */
type Props = {|
  /** Is visible */
  visible: boolean,
  /** Percentage complete */
  percent: number,
  /** "Spins" indefinitely */
  infinite?: boolean,
  /** Distance from top in pixels */
  topDistance?: number,
  /** For animating percentage loading only. */
  transitionDuration: string,
  /** Z-index */
  zIndex?: mixed,
|};

const LoadingBar = ({
  visible,
  topDistance,
  transitionDuration,
  infinite,
  percent,
  zIndex,
}: Props) => (
  <div
    className={classNames(styles.loadingBar, { [styles.infinite]: infinite })}
    style={{
      display: visible ? 'block' : 'none',
      top: topDistance,
      transitionDuration,
      zIndex,
    }}
  >
    <div
      className={styles.percentBar}
      style={{ width: `${percent}%`, display: percent > 0 ? 'block' : 'none' }}
    />
  </div>
);

LoadingBar.defaultProps = {
  infinite: false,
  percent: 0,
  topDistance: 0,
  transitionDuration: '500ms',
  visible: true,
  zIndex: 'auto',
};

export default LoadingBar;
